module.exports = __webpack_public_path__ + "img/_icon-change-my-address.967d7f53.svg";